export const MegaMenuMobileSeparatorItem = () => {
  return <hr className="border-t border-grey-300" />;
};
